import { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Mousewheel, Pagination,
} from 'swiper/modules';

import { Tooltip } from 'react-tooltip';
import { BiChevronDown } from 'react-icons/bi';
import HomeTwo from './HomeTwo';
import AboutTwo from './AboutTwo';
import Services from './Services';
import CounterUp from './CounterUp';
import Footer from './Footer';
import Skills from './Skills';
import Prices from './Prices';
import Portfolio from './Portfolio';
import Blog from './Blog';
import Contact from './Contact';
import Testimonials from './Testimonials';

// css
import 'react-tooltip/dist/react-tooltip.css';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import '../assets/style/customSwiper.scss';
import '../assets/style/customSwiperFour.scss';
import 'react-toastify/dist/ReactToastify.css';

const Public = () => {
  const toolTips = {
    0: 'Home',
    1: 'Testimonials',
    2: 'About',
    3: 'Services',
    4: 'Skills',
    5: 'CounterUp',
    6: 'Prices',
    7: 'Portfolio',
    8: 'Blog',
    9: 'Contact',
    10: 'Footer',
  };

  const pagination = {
    clickable: true,
    el: '.swiper-pagination',
    renderBullet(index, className) {
      return `<span class="${className}" data-tooltip-place="left" data-tooltip-id="${toolTips[index].toLowerCase()}-tooltip" data-tooltip-content="${toolTips[index]}"></span>`;
    },
  };

  const scrollContainerRef1 = useRef();
  const scrollContainerRef2 = useRef();
  const scrollContainerRef3 = useRef();
  const scrollContainerRef4 = useRef();
  const scrollContainerRef5 = useRef();
  const scrollContainerRef6 = useRef();
  const scrollContainerRef7 = useRef();
  const scrollContainerRef8 = useRef();
  const scrollContainerRef9 = useRef();
  const scrollContainerRef10 = useRef();
  const scrollContainerRef11 = useRef();

  const scrollContainerRefs = useRef([
    scrollContainerRef1,
    scrollContainerRef2,
    scrollContainerRef3,
    scrollContainerRef4,
    scrollContainerRef5,
    scrollContainerRef6,
    scrollContainerRef7,
    scrollContainerRef8,
    scrollContainerRef9,
    scrollContainerRef10,
    scrollContainerRef11,
  ]);

  useEffect(() => {
    const containers = scrollContainerRefs.current;

    const handleMousewheel = (event) => {
      const { deltaY } = event;
      const isScrollingUp = deltaY < 0;
      const isScrollingDown = deltaY > 0;

      const container = event.currentTarget;

      const isAtTop = Math.abs(container.scrollTop) === 0;
      const isAtBottom = Math.abs(container.scrollHeight
        - container.clientHeight - container.scrollTop) < 1;
      const hasScrollBar = container.scrollHeight > container.clientHeight;

      if (((isAtTop && isScrollingDown) && hasScrollBar)
        || (!isAtBottom && isScrollingDown) || (!isAtTop && isScrollingUp)) {
        event.stopPropagation();
      }
    };

    containers.forEach((container) => {
      container.addEventListener('wheel', handleMousewheel);
    });

    return () => {
      containers.forEach((container) => {
        container.removeEventListener('wheel', handleMousewheel);
      });
    };
  }, []);

  return (
    <div id="hello" style={{ height: '100%' }}>
      <header>
        <nav className="swiper-pagination" />
      </header>
      <Swiper
        tag="main"
        direction="vertical"
        slidesPerView={1}
        pagination={
          pagination
        }
        cssMode
        allowTouchMove={false}
        modules={[Mousewheel, Pagination]}
        className="mySwiper"
        style={{
          height: '100%',
        }}
      >
        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="my-home nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[0] = el); }}
          >
            <HomeTwo />
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="my-testimonials testimonials-section nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[1] = el); }}
          >
            <h1 className="testimonials-section--header-h1"><span>What people say</span></h1>
            <Testimonials />
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="about-me nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[2] = el); }}
          >
            <AboutTwo />
            <svg className="svg-about" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <defs>
                <linearGradient id="myGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: 'black' }} />
                  <stop offset="100%" style={{ stopColor: '#2F2FA2' }} />
                </linearGradient>
              </defs>

              <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" fill="url(#myGradient)" />
            </svg>

          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section " tag="section">
          <div
            className="my-services nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[3] = el); }}
          >
            <h1 className="solid-underline">Services</h1>

            <Services />
            <svg className="svg-services" xmlns="http://www.w3.org/2000/svg" version="1.1" width="700" height="700">
              <defs />
              <g id="two-0" transform="matrix(1 0 0 1 0 0)" opacity="1"><path transform="matrix(1 0 0 1 350 350)" id="two-62" d="M 320.789657 89.881046 C 312.197795 125.426606 247.180883 110.052684 218.706089 132.998119 C 200.578681 147.605466 187.727601 169.482406 178.067928 190.664195 C 163.450287 222.717847 186.991416 287.136071 152.500838 294.313258 C 85.697857 308.214375 95.055297 135.049465 27.009946 129.978997 C 9.386636 128.665779 -0.099314 153.700465 -11.440452 167.253479 C -49.982785 213.312773 -53.685312 327.028605 -113.092787 318.212604 C -150.687066 312.633656 -119.710926 234.668049 -146.906104 208.118534 C -166.760236 188.735775 -214.397244 209.63735 -227.851307 185.370787 C -244.349655 155.613369 -185.81179 117.801872 -198.925322 86.40546 C -211.527539 56.233236 -288.726617 71.918681 -286.111504 39.325121 C -281.585 -17.091148 -134.899279 38.502725 -124.138153 -17.062397 C -117.137341 -53.211122 -186.894804 -60.401704 -208.198401 -90.433328 C -232.277396 -124.377423 -278.326954 -173.002061 -255.068133 -207.513318 C -235.096835 -237.146576 -180.643113 -219.359805 -146.781421 -207.9419 C -107.291318 -194.626138 -85.382359 -115.86071 -46.583525 -131.073477 C 2.454748 -150.301061 -72.170487 -283.490023 -19.728016 -288.413379 C 28.42551 -292.934085 -13.559344 -168.909919 31.389661 -151.055345 C 52.928134 -142.499867 71.224921 -183.300059 94.370683 -182.127152 C 112.950379 -181.185629 123.98555 -156.234589 142.146773 -152.202031 C 186.165514 -142.428015 258.580759 -209.718182 277.760255 -168.909753 C 304.271038 -112.502461 128.023647 -100.420375 140.357742 -39.326396 C 147.692966 -2.993124 215.313523 -21.411032 245.570421 -0.000001 C 277.142085 22.341414 329.876735 52.286715 320.789657 89.881046 Z " fill="hsl(335, 77%, 50%)" stroke="undefined" strokeWidth="1" strokeOpacity="1" fillOpacity="1" visibility="visible" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="4" /></g>
            </svg>

            <svg className="svg-services-2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 700 700" style={{ overflow: 'hidden', display: 'block' }} width="700" height="700">
              <defs />
              <g id="two-0" transform="matrix(1 0 0 1 0 0)" opacity="1"><path transform="matrix(1 0 0 1 350 350)" id="two-62" d="M 320.789657 89.881046 C 312.197795 125.426606 247.180883 110.052684 218.706089 132.998119 C 200.578681 147.605466 187.727601 169.482406 178.067928 190.664195 C 163.450287 222.717847 186.991416 287.136071 152.500838 294.313258 C 85.697857 308.214375 95.055297 135.049465 27.009946 129.978997 C 9.386636 128.665779 -0.099314 153.700465 -11.440452 167.253479 C -49.982785 213.312773 -53.685312 327.028605 -113.092787 318.212604 C -150.687066 312.633656 -119.710926 234.668049 -146.906104 208.118534 C -166.760236 188.735775 -214.397244 209.63735 -227.851307 185.370787 C -244.349655 155.613369 -185.81179 117.801872 -198.925322 86.40546 C -211.527539 56.233236 -288.726617 71.918681 -286.111504 39.325121 C -281.585 -17.091148 -134.899279 38.502725 -124.138153 -17.062397 C -117.137341 -53.211122 -186.894804 -60.401704 -208.198401 -90.433328 C -232.277396 -124.377423 -278.326954 -173.002061 -255.068133 -207.513318 C -235.096835 -237.146576 -180.643113 -219.359805 -146.781421 -207.9419 C -107.291318 -194.626138 -85.382359 -115.86071 -46.583525 -131.073477 C 2.454748 -150.301061 -72.170487 -283.490023 -19.728016 -288.413379 C 28.42551 -292.934085 -13.559344 -168.909919 31.389661 -151.055345 C 52.928134 -142.499867 71.224921 -183.300059 94.370683 -182.127152 C 112.950379 -181.185629 123.98555 -156.234589 142.146773 -152.202031 C 186.165514 -142.428015 258.580759 -209.718182 277.760255 -168.909753 C 304.271038 -112.502461 128.023647 -100.420375 140.357742 -39.326396 C 147.692966 -2.993124 215.313523 -21.411032 245.570421 -0.000001 C 277.142085 22.341414 329.876735 52.286715 320.789657 89.881046 Z " fill="#2F2FA2" stroke="undefined" strokeWidth="1" strokeOpacity="1" fillOpacity="1" visibility="visible" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="4" /></g>
            </svg>
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="my-skills nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[4] = el); }}
          >
            <div className="my-skills--bg">
              <Skills />
              <div style={{ maxWidth: '100vw', overflow: 'hidden' }}>
                <svg className="svg-skills" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 800 800">
                  <defs>
                    <filter id="bbblurry-filter" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                      <feGaussianBlur stdDeviation="40" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur" />
                    </filter>
                  </defs>
                  <g filter="url(#bbblurry-filter)">
                    <ellipse className="ball1" rx="150" ry="150" cx="341.17568047778514" cy="456.971251700555" fill="hsl(37, 99%, 67%)" />
                    <ellipse className="ball2" rx="150" ry="150" cx="236.6344776852926" cy="421.6594387152858" fill="hsl(316, 73%, 52%)" />
                    <ellipse className="ball3" rx="150" ry="150" cx="462.0983943870794" cy="370.56218116099717" fill="hsl(185, 100%, 57%)" />
                    <ellipse className="ball4" rx="150" ry="150" cx="553.5353" cy="470.56218116099717" fill="#1933ba" />
                  </g>

                </svg>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="my-counter nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[5] = el); }}
          >
            <CounterUp />
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="my-prices nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[6] = el); }}
          >
            <h1 className="my-prices-h1">
              <div className="circle-inner-dot" />
              Prices
            </h1>
            <Prices />
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section" tag="section">
          <div
            className="my-portfolio nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[7] = el); }}
          >
            <Portfolio />
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section blog-section" tag="section">
          <div
            className="my-blogs nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[8] = el); }}
          >
            <Blog />
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section contact-section" id="contact-section" tag="section">
          <div
            className="my-contacts nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[9] = el); }}
          >
            <h1 className="contact-h1">
              Contact
              <svg width="400" height="35" xmlns="http://www.w3.org/2000/svg">
                <path
                  id="pathItem"
                  d="M60 80 Q 90 1 570 20"
                  stroke="#f64c72"
                  fill="transparent"
                  strokeWidth="1"
                  strokeLinecap="round"
                />
              </svg>

            </h1>
            <Contact />
            <div className="wrapper-scroll-bar">
              {/* <p>Scroll Down</p> */}
              <div className="container-scroll-bar">
                <div className="scroll-bar" />
                <div className="arrow-scroll-bar">
                  <i className="fas fa-chevron-down">
                    <BiChevronDown />
                  </i>
                </div>
              </div>
            </div>

            <svg className="svg-contact" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <defs>
                <linearGradient id="myGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#000' }} />
                  <stop offset="100%" style={{ stopColor: '#2F2FA2' }} />
                </linearGradient>
              </defs>
              <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill" fill="url(#myGradient)" />
              <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill" fill="url(#myGradient)" />
              <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill" fill="url(#myGradient)" />
            </svg>

          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-section bubble-section" tag="section">
          <div
            className="my-footer nested-scroll"
            ref={(el) => { (scrollContainerRefs.current[10] = el); }}
          >
            <Footer />
          </div>
        </SwiperSlide>
      </Swiper>

      <Tooltip className="react-tooltip" id="home-tooltip" />
      <Tooltip className="react-tooltip" id="about-tooltip" />
      <Tooltip className="react-tooltip" id="services-tooltip" />
      <Tooltip className="react-tooltip" id="skills-tooltip" />
      <Tooltip className="react-tooltip" id="prices-tooltip" />
      <Tooltip className="react-tooltip" id="portfolio-tooltip" />
      <Tooltip className="react-tooltip" id="blog-tooltip" />
      <Tooltip className="react-tooltip" id="contact-tooltip" />
      <Tooltip className="react-tooltip" id="test-tooltip" />
    </div>
  );
};

export default Public;
